import React, { useEffect, useRef, useState } from 'react';

export default function ExpandableTextarea({
  value,
  onChange,
  rows = 2,
  expandedRows = 6,
  placeholder,
  style,
  disabled,
  readOnly,
}) {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const text = value ?? '';

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const frame = window.requestAnimationFrame(() => {
      setHasMore(element.scrollHeight > element.clientHeight + 1);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [text, expanded, rows, expandedRows]);

  const showToggle = hasMore || expanded;

  return (
    <div style={wrapStyle}>
      <div style={textareaWrapStyle}>
        <textarea
          ref={ref}
          value={text}
          rows={expanded ? expandedRows : rows}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(event) => onChange(event.target.value || null)}
          style={{ ...textareaStyle, ...(style || {}) }}
        />
        {!expanded && hasMore && <div style={fadeStyle} />}
      </div>
      {showToggle && (
        <button type="button" style={toggleStyle} onClick={() => setExpanded((current) => !current)}>
          {expanded ? '접기' : '더보기 · 내용 더 있음'}
        </button>
      )}
    </div>
  );
}

const wrapStyle = { display: 'grid', gap: 4, minWidth: 0 };
const textareaWrapStyle = { position: 'relative', minWidth: 0 };
const textareaStyle = {
  width: '100%',
  minHeight: 52,
  boxSizing: 'border-box',
  resize: 'vertical',
  lineHeight: 1.35,
};
const fadeStyle = {
  position: 'absolute',
  left: 1,
  right: 1,
  bottom: 1,
  height: 20,
  pointerEvents: 'none',
  borderRadius: '0 0 4px 4px',
  background: 'linear-gradient(to bottom, rgba(255,255,255,0), var(--bg-card, #fff))',
};
const toggleStyle = {
  justifySelf: 'start',
  padding: 0,
  border: 'none',
  background: 'transparent',
  color: 'var(--accent-700, #2563eb)',
  fontSize: 11,
  fontWeight: 800,
  cursor: 'pointer',
};
